import React, { Component } from "react";
import axios from "axios";

import constants from "../../../constants";
import DataHandler from "./DataHandler";

import BarTitle from "../../../components/BarTitle";
import Painel from "../../../components/Painel";
import Transactions from "../../../components/Transactions";

class TransactionsView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tableData: []
    };

    this.setFilter = this.setFilter.bind(this);
  }

  setFilter(e) {
    this.setState({ filter: e.target.value });
  }

  filterData(data, filter) {
    return data.filter(item => {
      return Object.keys(item).some(key =>
        ("" + item[key]).toLowerCase().includes(filter.toLowerCase())
      );
    });
  }

  componentDidMount() {
    const url = constants().URL_SERVICE + "transactions";

    axios
      .post(url, {}, { headers: { token: localStorage.token } })
      .then(response => {
        this.setState({ tableData: DataHandler(response.data) });
      })
      .catch(error => this.setState({ error: true }));
  }

  render() {
    const data = this.state.tableData;
    const filter = this.state.filter;
    const tableData = !filter ? data : this.filterData(data, filter);

    return (
      <div>
        <BarTitle name="Clientes" />
        <div className="wrapper-md">
          <Painel title="Clientes">
            <div className="input-group panel">
              <span className="input-group-addon" id="filter-addon">
                Buscar
              </span>
              <input
                type="text"
                className="form-control"
                aria-describedby="filter-addon"
                onChange={this.setFilter}
              />
            </div>
            <Transactions tableData={tableData} />
          </Painel>
        </div>
      </div>
    );
  }
}

export default TransactionsView;



// WEBPACK FOOTER //
// ./src/views/Cielo/Transactions/index.js